import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ServicesProvider } from 'src/providers/services';
import { Router } from '@angular/router';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-advertisement',
  templateUrl: './advertisement.page.html',
  styleUrls: ['./advertisement.page.scss'],
})
export class AdvertisementPage implements OnInit {
  addImg: any;
  module : any;
  VendorId : any;
  DocName : any;
  ClinicId : any;
  Speciality : any;
  addtype : any;
  addtypestatus : any = "false";
  profileVideo : any;

  constructor(
    public service: ServicesProvider,
    public modalCtrl: ModalController,
    public router : Router,
    public addCall: AddCall,
  ) { }

  ngOnInit() {}

  ionViewWillEnter(){
    debugger;
    console.log(this.VendorId,"===================",this.addImg);
    if(this.addtype){
      this.addtypestatus = "true";
      this.addtype = this.addtype.toLowerCase();
    }else{
      this.addtypestatus = "false";
      this.addtype = this.addtype.toLowerCase();
    }
    
  }

  onVideoLoad() {
    this.profileVideo = document.getElementById('profileVideo')
    this.profileVideo.play();
    console.log('Video is loaded and ready to play');
    // Additional actions can be performed here
  }
  dismis() {
    window.localStorage['isAddOpened'] = 0;
    // this.modalCtrl.dismiss();
    this.modalCtrl.dismiss({
      isClosedPopUp: true,
    });
    console.log('addpage');
  }

  gotoModule(){

    console.log(this.module,"check the module");
    // this.modalCtrl.dismiss();
    this.modalCtrl.dismiss({
      isClosedPopUp: true,
    });
    // if(this.module == 'TrainingCenter'){
    //   this.router.navigate(['/tabs/trainingCenter']);
    //   localStorage.setItem("NopayGoBack", "newEnter");
    // }

    switch(this.module){
      case 1:{
        this.router.navigate(['/tabs/doctors-list', {frmAd : 1,docid : this.VendorId,docname : this.DocName,clinicid : this.ClinicId}]);
        break;
      }
      case 2 : {
        this.router.navigate(['/tabs/lab',{frmAd : 1,vendorId : this.VendorId}]);
        localStorage.setItem("NopayGoBack", "newEnter");
        break;
      }
      case 3 : {
        break;
      }
      case 4 : {
        break;
      }
      case 5 : {
        this.router.navigate(['/tabs/nursing']);
        localStorage.setItem("NopayGoBack", "newEnter");
        break;
      }
      case 6 : {
        this.router.navigate(['/tabs/trainer']);
        localStorage.setItem("NopayGoBack", "newEnter");
        break;
      }
      case 7 : {
        console.log(typeof(this.module));
        this.router.navigate(['/tabs/trainingCenter']);
        localStorage.setItem("NopayGoBack", "newEnter");
        break;
      }
      case 8 : {
        this.router.navigate(['/tabs/dietmeal',{frmAd : 1,vendorId : this.VendorId}]);
        localStorage.setItem("NopayGoBack", "newEnter");
        break;
      }
      case 9 : {
        this.router.navigate(['/tabs/prescription', { frmPage: 'Details' }]);
        localStorage.setItem("NopayGoBack", "newEnter");
        break;
      }
      case 10 : {
        this.router.navigate(['/tabs/booking-room']);
        localStorage.setItem("NopayGoBack", "newEnter");
        break;
      }
      case 11 : {
        break;
      }
      case 12 : {
        this.router.navigate(['/tabs/newphysiotherapy']);
        localStorage.setItem("NopayGoBack", "newEnter");
        break;
      }
    }
    
    
  }
}
